////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const itemCatalogDetail = {
	getItemCatalogDetail: (idItem) => ({
		type: ActionsTypes.GET_ITEM_CATALOG_DETAIL,
		payload: {
			idItem,
		},
	}),
	getItemCatalogDetailSuccess: (data) => ({
		type: ActionsTypes.GET_ITEM_CATALOG_DETAIL_SUCCESS,
		payload: {
			data,
		},
	}),
	getItemCatalogDetailFailure: (error) => ({
		type: ActionsTypes.GET_ITEM_CATALOG_DETAIL_FAILURE,
		payload: {
			error,
		},
	}),
	setSaleByArticle: (row) => ({
		type: ActionsTypes.SET_ITEM_CATALOG_DETAIL_SALEBYARTICLE,
		payload: {
			row,
		},
	}),
	getStocksFiltersInfo: (row) => ({
		type: ActionsTypes.GET_ITEM_CATALOG_DETAIL_FILTERS_STOCKS,
		payload: {
			row,
		},
	}),
	resetItemCatalogDetail: () => ({
		type: ActionsTypes.RESET_ITEM_CATALOG_DETAIL,
	}),
}

export default itemCatalogDetail
